import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import './registerServiceWorker'
// plugins
import './plugins/vue-axios'
import './plugins/vue-auth'
import './plugins/vue-analytics'
import vuetify from './plugins/vuetify'
import './plugins/notifications'
import './plugins/confirm'
import './plugins/validator'
import './plugins/google-maps'
import './plugins/helpers'

//css test
import './assets/css/main.css';

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')


